import { useEffect, useState } from "react";
import HeaderClientes from "components/_refactor/headers/clients";
import SolicitarDevolucaoStep1 from "./view/solicitar-devolucao-step1";
import SolicitarDevolucaoStep2 from "./view/solicitar-devolucao-step2";
import Api from "lib/api/httpRequestHelper";

const PLATAFORM_LIST = [
  { plataform: "Karsten", id: 1 },
  { plataform: "Truardi", id: 3 },
  { plataform: "Karsten Decor", id: 2 },
];

export default function SolicitarDevolucao() {
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [groupName, setGroupName] = useState("");
  const [socialName, setSocialName] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [plataform, setPlataform] = useState(PLATAFORM_LIST[0]);

  const [selectedReason, setSelectedReason] = useState();
  const [selectedReasonComplete, setSelectedReasonComplete] = useState();
  const [selectedDefect, setSelectedDefect] = useState();
  const [selectedDefectComplete, setSelectedDefectComplete] = useState();

  const [items, setItems] = useState([]);
  const [solicitacao, setSolicitacao] = useState();

  useEffect(() => {
    const { search } = window.location;
    if (search) {
      const solicitacaoId = search.substring(1);
      setSolicitacao({ Id: solicitacaoId });
    }
  }, []);

  useEffect(() => {
    if (solicitacao && step === 1) {
      fetchSolicitationDetails();
    }
  }, [solicitacao]);

  const fetchSolicitationDetails = async () => {
    setIsLoading(true);
    try {
      const response = await Api.get(
        "list-request-reason",
        "trocasDevolucoes",
        `?page=0&idSolicitacao=${solicitacao.Id}`,
        true
      );

      if (response.Result.ListSolicitacao.length > 0) {
        const solicitationData = response.Result.ListSolicitacao[0];

        const itemsList = solicitationData.ListSolicitacaoItens?.map(
          (item) => ({
            idProduto: item.IdProduto,
            name: item.NomeProduto,
            quantidade: item.Quantidade,
            idMotivo: item.IdDevolucaoMotivo,
            motivo: item.Motivo || undefined,
            idDefeito: item.IdDevolucaoDefeito || undefined,
            defeito: item.Defeito || undefined,
            emailEnvio: item.emailEnvio || "",
            images: [],
          })
        );
        const imagesData = await solicitationData.Imagens;

        for (const item of itemsList) {
          item.images = imagesData.filter(
            (image) => image.IdProduto === item.idProduto
          );
        }

        setItems(itemsList);

        setGroupName({
          Id: solicitationData.IdGrupoEconomico,
          Nome: solicitationData.Empresa,
        });

        setSocialName({
          Id: solicitationData.IdPessoaLoja,
          Nome: solicitationData.Empresa,
          CNPJ: solicitationData.CNPJ || "",
        });

        setPlataform(
          PLATAFORM_LIST.find((p) => p.id === solicitationData.IdMarca) ||
            PLATAFORM_LIST[0]
        );
      }
    } catch (error) {
      console.error("Erro ao buscar detalhes da solicitação:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setStep(1);
    setGroupName("");
    setSocialName("");
    setCnpj("");
    setPlataform(PLATAFORM_LIST[0]);
    setSelectedReason(undefined);
    setSelectedReasonComplete(undefined);
    setSelectedDefect(undefined);
    setSelectedDefectComplete(undefined);
    setSolicitacao(undefined);
    setItems([]);
  };

  const commonProps = {
    groupName,
    setGroupName,
    socialName,
    setSocialName,
    cnpj,
    setCnpj,
    plataform,
    setPlataform,
    solicitacao,
    setSolicitacao,
    setStep,
  };

  const step1Props = {
    ...commonProps,
    plataformList: PLATAFORM_LIST,
    selectedReason,
    setSelectedReason,
    selectedReasonComplete,
    setSelectedReasonComplete,
    selectedDefect,
    setSelectedDefect,
    selectedDefectComplete,
    setSelectedDefectComplete,
    isLoading,
    setIsLoading,
    item: items,
    setItem: setItems,
  };

  const step2Props = {
    ...commonProps,
    selectedReasonComplete,
    handleClear,
    setItem: setItems,
  };

  return (
    <div>
      <HeaderClientes section="Solicitar Devolução" subsection="Clientes" />

      {step === 1 && <SolicitarDevolucaoStep1 {...step1Props} />}
      {step === 2 && <SolicitarDevolucaoStep2 {...step2Props} />}
    </div>
  );
}
